import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { EnvService } from "../core/env.service";

@Injectable({
  providedIn: "root",
})
export class ContactService {
  url = "unset";
  token =
    "bf1f05d97ff27d471a91215990f625ff73e1670688df4b7110e97b072d83f892de5e0bdb2f7b38070aaab1aced161c4509153f486fcb08dfa4dbd223e8acd5d285356c673c8e39339f2e17fb64c50013973ed7d68bbee492e15c6ad6b81537a161403b5f633206e20f37e106c9b5886fa21c0d07510a7496db229196d20d84d9";
  constructor(private http: HttpClient, private env: EnvService) {
    this.url = this.env.strapiServer + "/strapi/api/";
    console.log("StrapiService", this.url);
  }

  getContacts(page = 1, pageSize = 100) {
    return this.http.get<any>(
      this.url +
        `contacts?pagination[page]=${page}&pagination[pageSize]=${pageSize}&populate=*`,
      this.getHeader()
    );
  }

  getNeoContacts(page = 1, pageSize = 100) {
    return this.http.get<any>(
      this.url +
        `neo-contacts?pagination[page]=${page}&pagination[pageSize]=${pageSize}&populate=*`,
      this.getHeader()
    );
  }

  getHeader() {
    return {
      headers: new HttpHeaders({
        Authorization: `bearer ${this.token}`,
        "Content-Type": "application/json",
      }),
    };
  }

  addContact(contact: any) {
    return this.http.post<any>(
      this.url + "contacts",
      { data: contact },
      this.getHeader()
    );
  }

  updateContact(contact: any) {
    return this.http.put<any>(
      this.url + "contacts/" + contact.id + "?populate=*",
      { data: contact },
      this.getHeader()
    );
  }

  getAllNeoContacts() {
    return this.http.get<any>(
      this.url + "neo-contacts?populate=*",
      this.getHeader()
    );
  }

  getAllContacts() {
    return this.http.get<any>(this.url + "contacts", this.getHeader());
  }

  addNeoContact(contact: any) {
    return this.http.post<any>(
      this.url + "neo-contacts",
      { data: contact },
      this.getHeader()
    );
  }
  updateNeoContact(contact: any) {
    return this.http.put<any>(
      this.url + "neo-contacts/" + contact.id + "?populate=*",
      { data: contact },
      this.getHeader()
    );
  }
}
